import React from 'react';
import { useShipForm } from '../../../context/shipForms';
import edit from '../../../assets/icons/new_icon/edit-white.svg';
import SpecialInstruction from '../../global-components/specialInstruction';

interface Props {
  setCurrentShipmentStatus: any;
  setEditRouteForm: any;
  data?: any;
  handleEdit?: any;
  isAddLeg?: any;
}
function SpecialInstructionsFields({
  setCurrentShipmentStatus,
  setEditRouteForm,
  data,
  isAddLeg,
  handleEdit,
}: Props) {
  const { getSpecialInstructionContext } = useShipForm();
  const specialInstructions: any = getSpecialInstructionContext();
  return (
    <div className='ubbe-card h-100'>
      <div className='ubbe-card-header d-flex justify-content-between'>
        <h5 className='ps-3 mb-0 GlobalBoxHead'>Special Instructions</h5>
        <div
          className='my-auto'
          style={{ paddingRight: '20px' }}
        >
          <button
            type='button'
            className='editwhiteBg'
            data-testid='editButton'
            onClick={() => {
              if (isAddLeg) {
                handleEdit();
              } else {
                setCurrentShipmentStatus('select-route');
                setEditRouteForm(true);
              }
            }}
          >
            <img
              src={edit}
              alt={edit}
            />
          </button>
        </div>
      </div>
      <div
        className={`card-body p-4 ${isAddLeg && 'pt-0'} h-auto ${
          isAddLeg && !data ? 'spInsAddLeg' : ''
        }`}
      >
        <div className='row mt-2'>
          <div className='col-md-12'>
            {specialInstructions || (data && data) ? (
              <>
                <label
                  id='special_instructions'
                  style={{ lineBreak: 'anywhere' }}
                >
                  {data ? data : specialInstructions}
                </label>
              </>
            ) : (
              <>
                <SpecialInstruction />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SpecialInstructionsFields;
